import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@coval/ui"

interface DeleteNotebookDialogProps {
  open: boolean
  title: string
  pending: boolean
  onClose: () => void
  onConfirm: () => void
}

/** Standard destructive confirmation, matching the Reports delete dialog. */
export function DeleteNotebookDialog({
  open,
  title,
  pending,
  onClose,
  onConfirm,
}: DeleteNotebookDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !pending && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Notebook</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p>
            Are you sure you want to delete <strong>{title}</strong>? This
            action cannot be undone.
          </p>
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onClose} disabled={pending}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={pending}
            aria-busy={pending}
          >
            {pending ? "Deleting…" : "Delete"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
